export const messages = {
  en: {
    BonusCalc: {
      Title: "Calculate the income of the whole family",
      FamilySize: "Family size",
      PurchaseAmount: "Purchase amount",
      PointsEarned: "Points earned",
      Year: "Year",
      Month: "Month",
      ShortScore: "B",
      BecomeClient: "Become a client",
      OfferText:
        "The presented calculation is for informational purposes and is not an offer. This calculation is presented taking into account purchases by favorite categories and partners of the bank.",
    },
  },
  ru: {
    BonusCalc: {
      Title: "Рассчитайте доходы всей семьи",
      FamilySize: "Численность семьи",
      PurchaseAmount: "Сумма покупок",
      PointsEarned: "Сумма заработанных баллов",
      Year: "Год",
      Month: "Месяц",
      ShortScore: "Б",
      BecomeClient: "Стать клиентом",
      OfferText:
        "Представленный рассчет носит инфомарционный характер и не является офертой. Данный рассчет представлен с учетом покупок по любимым категориям и партнеров банка.",
    },
  },

  jp: {
    BonusCalc: {
      Title: "家族のボーナスと収入を計算する",
      FamilySize: "ファミリーサイズ",
      PurchaseAmount: "購入金額",
      PointsEarned: "獲得ポイント",
      Year: "年",
      Month: "月",
      ShortScore: "B",
      BecomeClient: "クライアントになる",
      OfferText:
        "提示された計算は情報提供を目的としたものであり、申し出ではありません。 この計算は、銀行のお気に入りのカテゴリとパートナーによる購入を考慮して提示されています。",
    },
  },
};
